"use client";

import Logo from "@/assets/logos/doctor_m_logo.svg?react";
import { useIsClient } from "@/hooks/useIsClient";
import Image from "next/image";
import { memo, useEffect, useState } from "react";
import { CLink } from "../common/customLink/CustomLink";
import Style from "./style.module.css";

const DELAY = 2000;

const OnceAnimatedBrandLogo = () => {
  //states
  const [showAnim, setShowAnim] = useState(true);
  const [isFirstTime, setIsFirstTime] = useState(true);

  // hooks
  const isClient = useIsClient();

  // methods
  function handleAndSetBrandLogo() {
    setTimeout(() => {
      setShowAnim(false);
      sessionStorage.setItem("animatedLogo", "true")
      // localStorage.setItem("animatedLogo", "true");
    }, DELAY);
  }

  // effects
  useEffect(() => {
    // setIsFirstTime(localStorage.getItem("animatedLogo") === null);
    setIsFirstTime(sessionStorage.getItem("animatedLogo") === null);
  }, []);

  if (!isClient) return <></>;

  return (
    <>
      {showAnim && isFirstTime ? (
        <img
          src="/magrabi/images/doctor_m_logo.gif"
          alt="Brang Logo"
          width={295}
          className="fixed left-1/2 w-[210px] -translate-x-1/2 lg:w-[295px]"
          onLoad={handleAndSetBrandLogo}
        />
      ) : (
        <div className="flex items-center justify-center">
          <CLink href="/" className={Style["logo"]}>
            <Logo
              className="h-full w-full"
              viewBox="0 0 195 25"
              preserveAspectRatio="xMidYMid meet"
            />
          </CLink>
        </div>
      )}
    </>
  );
};

export default memo(OnceAnimatedBrandLogo);
